import { __awaiter } from "tslib";
import { trackShare, initEventTracker, } from '@slickdeals/web-instrumentation';
export const initWebInstrumentation = () => __awaiter(void 0, void 0, void 0, function* () {
    initEventTracker({
        client: {
            dataLayer: window.dataLayer,
            url: window.location.href,
            device: {
                userAgent: window.navigator.userAgent,
            },
        },
    });
});
export const addToWindow = () => {
    var _a;
    window.sdWebInstrumentation = Object.assign(Object.assign({}, ((_a = window.sdWebInstrumentation) !== null && _a !== void 0 ? _a : {})), { trackShare });
};
